// src/services/bankrollEngine.ts
import { BankrollState, BankrollTx, TxKind, BasePick, Side, Parlay, ParlayStatus, PickStatus, UUID, uid } from '../domain/types';

export const settlePick = (pick: BasePick & { stake: number }, realValue: number) => {
  const won = pick.side === Side.OVER ? realValue > pick.line : realValue < pick.line;
  const push = realValue === pick.line;
  const pnl = push ? 0 : won ? pick.stake * (pick.odds - 1) : -pick.stake;
  const status = push ? PickStatus.PUSH : won ? PickStatus.WON : PickStatus.LOST;
  return { status, pnl, push };
};

export const settleParlay = (parlay: Parlay, legResults: Map<string, { won: boolean; push: boolean }>) => {
  const anyPush = [...legResults.values()].some(r => r.push);
  const allWon  = [...legResults.values()].every(r => r.won || r.push);
  const anyLost = [...legResults.values()].some(r => !r.won && !r.push);

  let status: ParlayStatus;
  let pnl = 0;
  if (anyPush) { status = ParlayStatus.VOID; pnl = 0; }
  else if (allWon) { status = ParlayStatus.GREEN; pnl = parlay.stake * (parlay.combinedOdds - 1); }
  else { status = ParlayStatus.RED; pnl = -parlay.stake; }

  return { status, pnl, settledAt: new Date().toISOString() };
};

export const applyTx = (state: BankrollState, tx: BankrollTx): BankrollState => ({
  ...state,
  current: state.current + tx.amount,
  openStake: state.openStake + (tx.kind === TxKind.STAKE ? -tx.amount : tx.kind === TxKind.PAYOUT ? tx.amount : 0),
  history: [...state.history, { ...tx, balanceAfter: state.current + tx.amount }],
});

export const createStakeTx = (refType: 'pick' | 'parlay', refId: UUID, amount: number, note?: string): BankrollTx => ({
  id: uid(),
  ts: new Date().toISOString(),
  kind: TxKind.STAKE,
  refType,
  refId,
  amount: -Math.abs(amount),
  balanceAfter: 0, // será preenchido pelo applyTx
  note,
});

export const createPayoutTx = (refType: 'pick' | 'parlay', refId: UUID, amount: number, note?: string): BankrollTx => ({
  id: uid(),
  ts: new Date().toISOString(),
  kind: TxKind.PAYOUT,
  refType,
  refId,
  amount: Math.abs(amount),
  balanceAfter: 0,
  note,
});

export const initialBankrollState = (initial = 0): BankrollState => ({
  initial,
  current: initial,
  openStake: 0,
  history: [],
});
